
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';
import {ApiService} from '../../../@core/service/api.service';
import {
  BusinessModel,
  ContactModel,
  ParticipantModel,
  ProjectModel,
} from '../../../@models';
import {Subject} from 'rxjs';

@Component({
  selector: 'ngx-form-connected-projects',
  templateUrl: './form-connected-projects.component.html',
  styleUrls: ['./form-connected-projects.component.scss'],
})

export class FormConnectedProjectsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() title: string;
  @Input() value: ProjectModel[];

  @Output() valueChange: EventEmitter<ProjectModel[]> = new EventEmitter<ProjectModel[]>();

  @Input() edit: boolean = true;

  projectService: CompleterData;

  newParticipantName: string;
  newParticipant: ContactModel;

  isExternal: boolean;

  JSON = JSON;

  private projectSubject = new Subject();
  // customer: BusinessModel;
  private business: BusinessModel[];
  customer: string;

  constructor(private api: ApiService, private completerService: CompleterService) {
    this.projectSubject = new Subject();
    // this.api.reloadContacts({contactType: EContactType.Employee}).subscribe(x => this.contactSubject.next(x));

    this.projectService = this.completerService.local(
      this.projectSubject, 'title', 'title')

  }


  ngOnInit() {

    /*if (this.value != null) {
      this.con
    }*/
    /*this.api.reloadContacts().subscribe((contacts) => {
      this.autocomplete = contacts.map(x => {
        return {
          value: x._id,
          display: `${x.business.name}: ${x.title}`,
        };
      })
    });*/
    this.api.reloadBusiness().subscribe(x => {
      this.business = x;
      this.projectSubject.next([...x.map(y => y.projects.filter(f => f.active))])
    });

    this.reload();
  }

  ngOnDestroy(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    /*if (!this.changeCommited) {
      this.tagList = changes.value.currentValue.map(x => {
        return {
          value: x._id,
          display: `${x.business.name}: ${x.title}`,
        }
      });
    }*/
    // if (changes.value != null && changes.value.currentValue != null)
    // this.projectName = changes.value.currentValue.name;

    // this.changeCommited = false;
  }
  select(item: CompleterItem) {

    // console.log(item);
    if (item != null) {
      if (this.value == null) {
        this.value = [];
      }
      // console.log(item.originalObject);
      this.value.push(item.originalObject)

    }


    // const newName = `${this.newParticipant.business.name}: ${this.newParticipant.title}`
    // if (this.value.find(x => x.name === newName) != null)
//      return;
    /*this.value.push({
      contact: this.newParticipant._id,
      name: this.newParticipant.displayTitle,
      type: EParticipantType.Reference,
    });*/

    this.customer = '';
    this.valueChange.emit(this.value);
    this.newParticipant = null;
    this.newParticipantName = '';
      // this.newParticipant = item.originalObject;
    // this.changeCommited = true;
    // this.valueChange.emit();
  }

  selectOnlyCustomer(value: Boolean) {
    this.reload();

    // this.contactService.dataSourceChange =
    // this.api.reloadContacts({contactType: EContactType.Employee});
  }

  private reload() {
    // const filter: any = {contactType: EContactType.Employee};
    // if (this.onlyNrk) filter.type = EBusinessType.NRK;
    // if (this.onlyCustomer && this.businessId) filter.business = this.businessId;

  }

  addParticipant() {

  }


  remove(item: ParticipantModel) {
    this.value = this.value.filter(x => x.name !== item.name);
    this.valueChange.emit(this.value);

  }

  updateBusiness(business: any) {
    this.api.projectList().subscribe(x => {
      x.forEach(y => y.title = `[${y.businessUnit}] ${y.name}`);
      this.projectSubject.next(x.filter(y => y.business as undefined as string === business._id))
    });

  }
}
